var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgMyStores = function SvgMyStores(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#my-stores_svg__3bgke5x3ia)",
    fill: "#333"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.042 10H3.958v.792h11.084V10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.208 6.833A.792.792 0 0019 6.042V4.458a.792.792 0 00-.792-.791H17.1L16.032.997A.792.792 0 0015.297.5H3.703a.792.792 0 00-.735.498L1.9 3.667H.792A.792.792 0 000 4.458v1.584c0 .436.355.791.792.791h.791v11.875H0v.792h19v-.792h-1.583V6.833h.791zM3.703 1.292h11.594l.95 2.375H2.753l.95-2.375zM.792 6.042V4.458h17.416v1.584H.793zM4.75 18.708v-5.541h3.167v5.541H4.75zm6.333 0v-5.541h3.167v5.541h-3.167zm5.542 0h-1.583v-5.541a.793.793 0 00-.792-.792h-3.167a.792.792 0 00-.791.792v5.541H8.708v-5.541a.792.792 0 00-.791-.792H4.75a.793.793 0 00-.792.792v5.541H2.375V6.833h14.25v11.875z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "my-stores_svg__3bgke5x3ia"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 .5)",
    d: "M0 0h19v19H0z"
  })))));
};
export default SvgMyStores;